import api from "../../../../../utils/axiosInstance";
import VendorScopedSection from "../shared/VendorScopedSection";
import VendorSpecializationsTable from "./VendorSpecializationsTable";
import EditSpecializationsPage from "./EditSpecializationsPage";

const fetchData = async (vendorId) => {
  const [settingsRes, itemsRes] = await Promise.all([
    api.get(`/vendor-settings/${vendorId}`, { withCredentials: true }),
    api.get(`/vendor-specializations/${vendorId}/specializations`, {
      withCredentials: true,
    }),
  ]);

  const data = itemsRes.data?.data;
  const items = Array.isArray(data)
    ? data
    : Array.isArray(data?.specializations)
    ? data.specializations
    : [];

  return {
    worksWithAll: settingsRes.data?.data?.works_with_all_specializations || false,
    items,
  };
};

const onToggle = async (vendorId, newValue) => {
  await api.put(`/vendor-settings/${vendorId}`, {
    works_with_all_specializations: newValue,
  });
  if (!newValue) {
    await api.post("/vendor-specializations/initialize", {
      vendor_id: parseInt(vendorId),
    });
  }
};

const VendorSpecializationsPage = ({ vendorId }) => (
  <VendorScopedSection
    vendorId={vendorId}
    toggleLabel="Works with all specializations:"
    helperText="This vendor works with all specializations."
    sectionTitle="Specializations"
    containerMaxWidth="max-w-2xl"
    editModalTitle="Manage Vendor Specializations"
    editModalMaxWidth="max-w-2xl"
    fetchData={fetchData}
    onToggle={onToggle}
    renderTable={({ items }) => (
      <VendorSpecializationsTable specializations={items} />
    )}
    renderEdit={({ onComplete }) => (
      <EditSpecializationsPage
        vendorId={vendorId}
        onUpdateComplete={onComplete}
      />
    )}
  />
);

export default VendorSpecializationsPage;
